import type { Attachment, StorageFolderId } from '../types';

export const TRACKER_FOLDER_ID = 'system-tracker' as StorageFolderId;
export const MESSENGER_FOLDER_ID = 'system-messenger' as StorageFolderId;
export const KNOWLEDGE_FOLDER_ID = 'system-knowledge' as StorageFolderId;
export const MY_FILES_FOLDER_ID = 'system-my-files' as StorageFolderId;

export interface SystemFolder {
  id: StorageFolderId;
  name: string;
  personal: boolean;
}

export const SYSTEM_FOLDERS: readonly SystemFolder[] = [
  { id: TRACKER_FOLDER_ID, name: 'Трекер', personal: false },
  { id: MESSENGER_FOLDER_ID, name: 'Мессенджер', personal: false },
  { id: KNOWLEDGE_FOLDER_ID, name: 'База знаний', personal: false },
  { id: MY_FILES_FOLDER_ID, name: 'Мои файлы', personal: true },
];

export function isSystemFolderId(id: string): boolean {
  return SYSTEM_FOLDERS.some((folder) => folder.id === id);
}

export function attachmentFolderId(attachment: Pick<Attachment, 'folderId'>): StorageFolderId | null {
  return attachment.folderId ?? null;
}

export function homeFolderId(attachment: Pick<Attachment, 'ownerKind'>): StorageFolderId {
  switch (attachment.ownerKind) {
    case 'message':
      return MESSENGER_FOLDER_ID;
    case 'doc':
      return KNOWLEDGE_FOLDER_ID;
    case 'storage':
      return MY_FILES_FOLDER_ID;
    default:
      return TRACKER_FOLDER_ID;
  }
}

export function isPersonalAttachment(attachment: Pick<Attachment, 'ownerKind' | 'folderId'>): boolean {
  return attachment.ownerKind === 'storage' && attachmentFolderId(attachment) === null;
}
